import { ONBOARDING_STEPS, getStepById } from './onboardingSteps.config';

const ACTIVE_STEP_STATUSES = new Set(['in_progress', 'completed', 'skipped']);

export function getLaterStepIds(currentStepId) {
  return ONBOARDING_STEPS.filter((step) => step.id > currentStepId).map((step) => step.id);
}

export function hasLaterStepProgress(currentStepId, steps) {
  return getLaterStepIds(currentStepId).some((stepId) => {
    const config = getStepById(stepId);
    if (!config) return false;
    return ACTIVE_STEP_STATUSES.has(steps[config.key]);
  });
}

export function getClearStepBlockReason({
  currentStepId,
  steps,
  organisationId,
  profileId,
}) {
  const config = getStepById(currentStepId);
  if (!config) {
    return 'This step cannot be cleared.';
  }

  if (hasLaterStepProgress(currentStepId, steps)) {
    return 'Clear later steps first, or use Start over to reset the entire setup.';
  }

  if (config.key === 'organisation' && organisationId) {
    return 'Organisation is already created. Use Start over to reset the full setup.';
  }

  if (config.key === 'profile_users' && profileId) {
    return 'Profile is already created. Use Start over to reset the full setup.';
  }

  return null;
}

export function canClearCurrentStep(options) {
  return getClearStepBlockReason(options) === null;
}
